import { Button } from '@mui/material'
import Link from 'next/link'
import { AppRoutes } from '@/config/routes'
import { useTranslation } from 'react-i18next'

const buttonSx = { width: ['100%', 'auto'], height: '36px', px: 2 }

const CreateButton = ({ isPrimary }: { isPrimary: boolean }) => {
  const { t } = useTranslation()
  return (
    <Link href={AppRoutes.newSafe.create} passHref legacyBehavior>
      <Button
        data-testid="create-safe-btn"
        disableElevation
        size="small"
        variant={isPrimary ? 'contained' : 'outlined'}
        sx={buttonSx}
        component="a"
      >
        {t('newSafe.createAccount')}
      </Button>
    </Link>
  )
}

export default CreateButton
